import { Box, Button, Chip, Grid, Typography } from "@material-ui/core"
import React from "react"
import { useStyles } from "./card-pedido-pendente-styles"
import { toDateString } from "utils/to-date"
import { toDecimalString } from "utils/to-decimal"
import classNames from "classnames"
import { useThemeQueries } from "components/dialogs/dialog-adicionar-produto-com-subitem/util-styles"
import { ContinuarIcon } from "components/icons/continuar-icon"
import { PedidoModel } from "api/cardapio/models/pedido/pedido"

export type CardPedidoPendenteProps = {
    pedido: PedidoModel
    onClick: (id: string) => void
}

export const CardPedidoPendente = ({ pedido, onClick }: CardPedidoPendenteProps) => {
    const classes = useStyles()
    const { theme } = useThemeQueries()

    return (
        <Button
            className={classes.card}
            variant="outlined"
            color="default"
            fullWidth
            onClick={() => onClick(pedido.id)}
        >
            <Grid container>
                <Grid item xs container>
                    <Grid item xs={12}>
                        <Typography variant="h6" color="textPrimary" className={classes.textNota}>
                            N° Pedido: {' '}
                            {pedido.codigoPedido}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} className={classes.endAlign}>
                        <Typography variant="body2" color="textSecondary" className={classes.feitoEm}>
                            Feito em: {toDateString(pedido.dataCriacao, 'DD/MM/yyyy HH:mm')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Box my={2} />
                    </Grid>
                    <Grid item xs={true}>
                        <Chip
                            className={classes.total}
                            style={{
                                backgroundColor: theme.palette.warning.main,
                                color: theme.palette.getContrastText(theme.palette.warning.main),
                                height: theme.spacing(3)
                            }}
                            label={pedido.statusPedido.descricao}
                        />
                    </Grid>
                    <Grid item xs={'auto'}>
                        <Typography variant="body1" color="textPrimary" className={classNames(classes.total)}>
                            <Box component="span" className={classes.totalLabel}>Total:</Box> R$ {toDecimalString(pedido.valorTotalPedido)}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item xs="auto">
                    <ContinuarIcon tipo="BUTTON" />
                </Grid>
            </Grid>
        </Button>
    )
}